import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for the next drill', 'No more disconnected class ideas', 'No more repeating the same session because planning time ran out', 'No more wondering what progression should come next', 'No more building every class from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-navy relative overflow-hidden" data-id="element-59" data-mp="h4u4g4bzabpd">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-60" data-mp="vui4714ih2az">
        <div className="text-center mb-16" data-id="element-61" data-mp="vtylvjay8bwf">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-white" data-id="element-62" data-mp="qvx0grq1w0hs">
            Next week you can keep planning every class from scratch...
            <br data-id="element-63" data-mp="14t3j8marxz70" />
            <span className="text-gold" data-id="element-64" data-mp="zwmw9vfb9qvi">
              Or you can open a complete system and already know where to start.
            </span>
          </h2>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-65" data-mp="2c67rin8zji7z">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-66" data-mp="2m2b0od298h4f">
                <span className="text-gold mt-1" data-id="element-67" data-mp="2m570k6xnxfvi">▸</span>
                <span className="text-white/80" data-id="element-68" data-mp="2r2ozr5lvogqb">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-2" data-id="element-69" data-mp="2v2zh1ef4etkh">
            Taekwondo Instructor Ready does not replace your knowledge as an instructor.
          </p>
          <p className="text-xl text-white/80" data-id="element-70" data-mp="34tlo2k8rubrk">
            It gives you a system for using that knowledge with greater structure, consistency and
            efficiency.
          </p>
        </div>

        <div className="bg-cream-card border-2 border-gold rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-71" data-mp="3errosyiudbuu">
          <h3 className="text-2xl font-bold text-navy mb-6 text-center border-b border-gold-light pb-6" data-id="element-72" data-mp="3istrjpbyw61k">
            Everything included:
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-73" data-mp="1jolbo81qg98s">
            {finalIncludedItems.map(item => <div key={item} className="flex items-start gap-3" data-id="element-74" data-mp="1enfgm3klo9w3">
                <Check size={18} className="text-emerald-brand shrink-0 mt-0.5" data-id="element-75" data-mp="1si84bpan8wdr" />
                <span className="text-sm text-ink" data-id="element-76" data-mp="1novskfr2ck2f">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-77" data-mp="22djia5e89zkg">
            <p className="text-xl font-serif font-bold text-navy mb-2" data-id="element-78" data-mp="22gnthmq41vkm">
              🥋 TAEKWONDO INSTRUCTOR READY
            </p>
            <p className="text-sm text-ink-soft mb-8" data-id="element-79" data-mp="2bfsur0t2430h">
              150 ready-to-teach Taekwondo sessions designed to help instructors plan less, teach
              with more structure and develop students from beginner to advanced.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-80" data-mp="h3kt74m8cnvq">
              🟡 GET THE COMPLETE TAEKWONDO COACHING SYSTEM NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-ink-soft mb-6" data-id="element-81" data-mp="6wi84i9c13cv">
              <span data-id="element-82" data-mp="3pahpdbdqhex7">$27 USD</span>
              <span data-id="element-83" data-mp="3pbaphti6t66d">• Immediate Access</span>
              <span data-id="element-84" data-mp="3ua41fhhtsp4f">• Complete Digital Bundle</span>
            </div>
            <p className="text-lg font-serif font-bold text-navy" data-id="element-85" data-mp="3u8astwnnjuts">
              Stop building every class from scratch. Open the system, choose the session and teach.
            </p>
          </div>
        </div>
      </div>
    </section>;
}